import { makeAutoObservable } from 'mobx';

import { Invoice, InvoiceFilterFormValues, InvoiceFilters } from '../interfaces/invoice';
import { FilterStore } from '../../shared/util-stores';
import { paginationSmallListLimit } from '../../shared/constants/systemConstants';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import { invoicesService } from '../services/invoicesService';

class InvoicesStore {
  private entityId: number | null = null;
  invoices: Invoice[] = [];
  filterMethods: FilterStore<InvoiceFilterFormValues, 'billingDate'>;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    this.filterMethods = new FilterStore<InvoiceFilterFormValues, 'billingDate'>(
      this.handleGetInvoices,
      {
        elementsPerPage: paginationSmallListLimit,
      },
    );
  }

  setDefaultValues() {
    this.entityId = null;
    this.invoices = [];
    this.filterMethods.setDefaultValues();
  }

  getInvoices(entityId: number) {
    this.setEntityId(entityId);
    return this.filterMethods.getData();
  }

  private async handleGetInvoices(filterData: InvoiceFilters) {
    if (!this.entityId) {
      throw new Error('entityId is not set');
    }

    const data = await invoicesService.getInvoiceHistory(this.entityId, filterData);

    this.setInvoices(data.content);

    return data;
  }

  private setEntityId(entityId: number) {
    this.entityId = entityId;
  }

  private setInvoices(invoices: Invoice[]) {
    this.invoices = invoices;
  }
}

const invoicesStore = new InvoicesStore();

resetAllStore.addResetMethod(invoicesStore.setDefaultValues);

export { invoicesStore, InvoicesStore };
